module.exports = __webpack_public_path__ + "img/explainer-11.28c7552f.jpg";